/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useRef, useState } from 'react';

import { TCard } from '@/services/requests/Recommendation/types/template8';
import TableRow from './TableRow';

export type TProps = {
  template: string;
  column_header: {
    title: string;
    description?: string;
  }[];
  cards: TCard[];
};

export default function TableDesktop({
  template,
  column_header,
  cards,
}: TProps) {
  const prefixTemplateClass = `vitrine-template${template}`;

  const [visibleCards, setVisibleCards] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const tableRef = useRef<HTMLTableElement>(null);

  const isLoadingRef = useRef(isLoading);
  const visibleCardsRef = useRef(visibleCards);

  useEffect(() => {
    isLoadingRef.current = isLoading;
  }, [isLoading]);

  useEffect(() => {
    visibleCardsRef.current = visibleCards;
  }, [visibleCards]);

  function splitMilesText(text: string | undefined): {
    numberPart: string;
    unitPart: string;
  } {
    if (!text) {
      return {
        numberPart: '',
        unitPart: '',
      };
    }

    const [numberPart, ...rest] = text.split(' ');
    return {
      numberPart,
      unitPart: rest.join(' '), // garante que "milhas" ou qualquer outra unidade venha junto
    };
  }

  const handleScroll = () => {
    if (!tableRef.current) return;
    const rect = tableRef.current.getBoundingClientRect();
    const distanceFromViewportBottom = rect.bottom - window.innerHeight;
    if (distanceFromViewportBottom < 200 && !isLoadingRef.current && visibleCardsRef.current < cards.length) {
      loadMoreCards();
    }
  };

  const loadMoreCards = () => {
    setIsLoading(true);

    setTimeout(() => {
      setVisibleCards(prevCount => Math.min(prevCount + 10, cards.length));
      setIsLoading(false);
    }, 600);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [cards.length]);

  console.log('CARDS T', cards);
  return (
    <table
      ref={tableRef}
      className={`${prefixTemplateClass}__table ${prefixTemplateClass}__table--desktop`}
    >
      <thead>
        <tr>
          {column_header?.map(ch => (
            <th
              key={ch.title}
              className={`${prefixTemplateClass}__table__header`}
            >
              <div
                className={`${prefixTemplateClass}__table__header__container`}
              >
                <tgr-text-heading size="2xs" tag="span">
                  <span
                    className={`${prefixTemplateClass}__table__header__container__title`}
                  >
                    {ch.title}
                  </span>
                </tgr-text-heading>
                {ch.description && (
                  <tgr-text-description>{ch.description}</tgr-text-description>
                )}
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {cards?.slice(0, visibleCards).map(card => <TableRow prefixTemplateClass={prefixTemplateClass} card={card} splitMilesText={splitMilesText} />)}
        {isLoading && (
          <tr>
            <td colSpan={column_header.length + 1}>
              <div className={`${prefixTemplateClass}__table__loading`}>
                <tgr-loading />
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
